import React from 'react';
import { Link } from 'react-router-dom';
import { iconEditOrange } from '../../images';
import { apiRequest } from "../../configurations/authConfig";
import { useMsal } from "@azure/msal-react";

const AdminInvestmentType = () => {
 
    return (
        <div className="container-fluid">
           <nav className="nav-menu" aria-label="breadcrumb">
                <ol className="breadcrumb breadcrumb-bottom">
                    <li className="breadcrumb-item" aria-current="page">
                        <Link to="/admin">
                            Admin
                        </Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                       Investment Type
                    </li>
                </ol>
            </nav>
            <div style={{ "padding":"5px 15px"}} >
                <div className="body">
                <div className="table-responsive table-responsive-sm">
             <div className='project-block-none' style={{ paddingTop: '5px'}} >
             <div className="row" style={{ width: '80%'}} >
                <div className="col-sm-6">
                    <span className='inform-create-header'>Investment Type</span>
                </div>
            </div>
            <div className='row'>
                <div className="col-sm-6">
                    <button type="button" className="btn btn-sm btn-outline-success">
                        <i className="material-icons header-icon">add</i>
                        <span style={{ "verticalAlign" : "top"}} >Add Investment Type</span>
                        </button>
                </div>
            </div>
           
            <table className="table table-sm table-bordered table-hover" style={{ width: '30%' }} >
                <thead>
                    <tr>
                        <th>Investment Type</th>
                        <th>Status</th>
                        <th>Edit</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>OP : Operated Assess</td>
                        <td style={{ textAlign: 'center'}} >
                                <span>Active</span>
                            </td>
                        <td className='text-center-both'>
                            <img src={iconEditOrange} style={{ width: '25px'}} />
                        </td>
                        
                       
                    </tr>

                    <tr>
                        <td>Joint-Operated</td>
                        <td style={{ textAlign: 'center'}} >
                                <span>Active</span>
                            </td>
                        <td className='text-center-both'>
                        <img src={iconEditOrange} style={{ width: '25px'}} />
                        </td>
                       
                      
                    </tr>
                    <tr>
                        <td>JV : Joint Venture</td>
                        <td style={{ textAlign: 'center'}} >
                                <span>Active</span>
                            </td>
                        <td className='text-center-both'>
                        <img src={iconEditOrange} style={{ width: '25px'}} />
                        </td>
                        
                      
                    </tr>
                   
                   
                </tbody>
            </table>
           
         </div>
         </div>
                </div>
            </div>
        </div>
    );
  
}

export default AdminInvestmentType